(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bfcm-2024-template"]) return;
  try {
    
  class Countdown {
    constructor(el) {
      this.el = el;
      this.targetDate = new Date(el.getAttribute("date-time"));
      this.createCountDownParts()
      this.countdownFunction();
      this.countdownLoopId = setInterval(this.countdownFunction.bind(this), 1000)
    }
    createCountDownParts() {
      ["days", "hours", "minutes", "seconds"].forEach(part => {
        const wrapperEl = document.createElement("div");
        wrapperEl.classList.add("w-full", "aspect-w-11", "aspect-h-12");

        const partEl = document.createElement("div");
        partEl.classList.add("part", "w-full", "h-full", part);

        const textEl = document.createElement("div");
        textEl.classList.add("text");
        textEl.innerText = part;

        const numberEl = document.createElement("div");
        numberEl.classList.add("number");
        numberEl.innerText = 0;

        partEl.append(numberEl, textEl);
        wrapperEl.append(partEl);
        this.el.append(wrapperEl);

        this[part] = numberEl;
      })
    }

    countdownFunction() {
      const remaining = this.getTimes(this.targetDate);
      Object.entries(remaining).forEach(([part, value]) => {
        this[part].style.setProperty("--value", value)
        this[part].innerText = value
      })
    }

    getTimes = (time) => {
      const t = new Date(time).getTime();
      const offset = new Date().getTimezoneOffset() * 60 * 1000;
      const offsetTime = t - offset;
      return this.getPart(offsetTime);
    }

    getPart(endTime) {
      const current = Math.floor(Date.now() / 1000);
      let diff = Math.floor(endTime / 1000) - current;
      if (diff > 0) {
        let d = Math.floor(diff / (3600 * 24));
        let h = Math.floor((diff % (3600 * 24)) / (60 * 60));
        let m = Math.floor(((diff % (3600 * 24)) % (60 * 60)) / 60);
        let s = Math.floor(diff % 60);
        let days = d < 10 ? "0" + d : d;
        let hours = h < 10 ? "0" + h : h;
        let minutes = m < 10 ? "0" + m : m;
        let seconds = s < 10 ? "0" + s : s;
        return { days, hours, minutes, seconds }
      }
    }
  }
  const countdownEls = document.querySelectorAll(".countdown") || [];
  if (countdownEls.length > 0) {
    countdownEls.forEach(countdownEl => new Countdown(countdownEl));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-friday-2024-v2"]) return;
  try {
    
  class Countdown {
    constructor(el) {
      this.el = el;
      this.targetDate = new Date(el.getAttribute("date-time"));
      this.createCountDownParts()
      this.countdownFunction();
      this.countdownLoopId = setInterval(this.countdownFunction.bind(this), 1000)
    }
    createCountDownParts() {
      ["days", "hours", "minutes", "seconds"].forEach(part => {
        const wrapperEl = document.createElement("div");
        wrapperEl.classList.add("w-full", "aspect-w-11", "aspect-h-12");

        const partEl = document.createElement("div");
        partEl.classList.add("part", "w-full", "h-full", part);

        const textEl = document.createElement("div");
        textEl.classList.add("text");
        textEl.innerText = part;

        const numberEl = document.createElement("div");
        numberEl.classList.add("number");
        numberEl.innerText = 0;

        partEl.append(numberEl, textEl);
        wrapperEl.append(partEl);
        this.el.append(wrapperEl);

        this[part] = numberEl;
      })
    }
    countdownFunction() {
      const remaining = this.getTimes(this.targetDate);
      Object.entries(remaining).forEach(([part, value]) => {
        this[part].style.setProperty("--value", value)
        this[part].innerText = value
      })
    }
    getTimes = (time) => {
      const t = new Date(time).getTime();
      const offset = new Date().getTimezoneOffset() * 60 * 1000;
      const offsetTime = t - offset;
      return this.getPart(offsetTime);
    }
    getPart(endTime) {
      const current = Math.floor(Date.now() / 1000);
      let diff = Math.floor(endTime / 1000) - current;
      if (diff > 0) {
        let d = Math.floor(diff / (3600 * 24));
        let h = Math.floor((diff % (3600 * 24)) / (60 * 60));
        let m = Math.floor(((diff % (3600 * 24)) % (60 * 60)) / 60);
        let s = Math.floor(diff % 60);
        let days = d < 10 ? "0" + d : d;
        let hours = h < 10 ? "0" + h : h;
        let minutes = m < 10 ? "0" + m : m;
        let seconds = s < 10 ? "0" + s : s;
        return { days, hours, minutes, seconds }
      }
    }
  }
  const countdownEls = document.querySelectorAll(".countdown") || [];
  if (countdownEls.length > 0) {
    countdownEls.forEach(countdownEl => new Countdown(countdownEl));
  }
  let scrollX,scrollY,scrollDirection;
  function getScrollAction() {
    if (typeof scrollX == 'undefined') {
      scrollX = window.pageXOffset;
      scrollY = window.pageYOffset;
      scrollDirection = 'down';
    }
    var diffX = scrollX - window.pageXOffset;
    var diffY = scrollY - window.pageYOffset;

    if (diffX < 0) {
      // Scroll right
      scrollDirection = 'right';
    } else if (diffX > 0) {
      // Scroll left
      scrollDirection = 'left';
    } else if (diffY < 0) {
      // Scroll down
      scrollDirection = 'down';
    } else if (diffY > 0) {
      // Scroll up
      scrollDirection = 'up';
    }
    scrollX = window.pageXOffset;
    scrollY = window.pageYOffset;
  }
  var Sticky_Anchor = new hcSticky('.anchor-points', {
    stickTo: '#sticky_container',
    bottomEnd: 112,
    onStart: function(){
      const h_header = $('.header-wrapper').height();
      const h_shop = $('#sticky_container').offset().top;
      window.onscroll = function (e) {
        getScrollAction();
        if (scrollY > h_shop) {
          $('#sticky_container>.anchor-points').css('position', 'fixed');
          if (scrollDirection  == 'up') {
            $('#sticky_container>.anchor-points').css('top', h_header);
          }else{
            $('#sticky_container>.anchor-points').css('top', 0);
          }
        }else{
          $('#sticky_container>.anchor-points').css('position', 'static');
        }
      }
    }
  });
  setTimeout(function(){
    Sticky_Anchor.refresh();
  },3000);
  $(function () {
    const anchorPoints = $('#sticky_container>.anchor-points a'); // Select all anchor links
    const sections = Array.from(document.querySelectorAll('.content-section')); // Only include content sections
  
    // Click Event: Smooth Scroll and Active Class Management
    anchorPoints.on('click', function (e) {
      e.preventDefault();
      const targetId = $(this).data('target');
  
      // Remove the 'active' class from all anchor items
      anchorPoints.removeClass('active');
  
      // Add the 'active' class to the clicked anchor
      $(this).addClass('active');
  
      // Smooth scroll to the target section
      window.scrollTo({
        top: $(targetId).offset().top - 96, // Adjust offset for sticky menu
        behavior: 'smooth',
      });
    });
  
    // Scroll Event: Dynamic Active Class Management
    $(window).on('scroll', function () {
      let currentSection = '';
  
      // Determine the currently visible section
      sections.forEach((section) => {
        const sectionTop = section.offsetTop - 96; // Adjust for sticky menu height
        const sectionBottom = sectionTop + section.offsetHeight;
  
        // Check if the current scroll position is within the section's bounds
        if (window.pageYOffset >= sectionTop && window.pageYOffset < sectionBottom) {
          currentSection = `#${section.id}`;
        }
      });
  
      // Update the active class based on the current section
      anchorPoints.each(function () {
        const target = $(this).data('target');
        if (target === currentSection) {
          $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
      });
    });

    $('.shopBtn').click(function(){
      $(this).closest('.grid-container').find('.grid-product-item').find('.form_btn-open').click();
    })
  });

  var swiper_s5 = new Swiper('#swiper_s5',{
    slidesPerView: 1,
    watchOverflow: true,
    spaceBetween: 32,
    // autoHeight: true,
    grid: {
      fill: 'row',
      rows: 1,
    },
    breakpoints:{
      1024:{
        slidesPerView: 1,
        grid: {
          fill: 'row',
          rows: 3,
        },
      }
    },
    pagination: {
      el: '#pagination_s5',
      clickable: true,
      renderBullet: function (index, className) {
        switch(index){
          case 0: text = 'Phone Cases'; break;
          case 1: text = 'Watch Cases & Bands'; break;
          case 2: text = 'iPad Cases & Accessories'; break;
        }
        return '<div class="' + className + '"><span class="text-size-12 xs:text-size-14 sm:text-size-16 xl:text-size-18">' + text + '</span></div>';
      }
    }
  })
  // if (window.innerWidth >= 1024) {
  //   swiper_s5.disable()
  // }else{
  //   swiper_s5.enable()
  //   setTimeout(() => {
  //     swiper_s5.update();
  //   }, 3000);
  // }
  var swiper_s6 = new Swiper('#swiper_s6', {
    loop: true,
    spaceBetween: 8,
    // autoplay:true,
    speed: 1000,
    // simulateTouch: false,
    // allowTouchMove: false,
    on: {
      init:function(){
        this.emit('transitionEnd');
      },
      transitionEnd: function () {
        const index = this.realIndex;
        switch(index){
          case 0: text = 'noproblemo'; break;
          case 1: text = 'alien'; break;
          case 2: text = 'credit-card'; break;
        }
        $('.aries-product>.grid-product-item').find(`.toggle-item[data-color=${text}]`).trigger('click');
      }
    }
  });
  var swiper_s7 = new Swiper('#swiper_s7', {
    rewind: true,
    allowTouchMove: false,
    autoHeight: true,
    spaceBetween: 8,
    pagination: {
      el: '#pagination_s7',
      clickable: true,
      renderBullet: function (index, className) {
        switch(index){
          case 0: text = 'Phone Cases'; break;
          case 1: text = 'Watch Cases & Bands'; break;
          case 2: text = 'iPad Cases & Accessories'; break;
          case 3: text = 'Car Mount'; break;
        }
        return '<div class="' + className + '"><span class="text-size-12 xs:text-size-14 sm:text-size-16 xl:text-size-18">' + text + '</span></div>';
      }
    }
  });
  
  document.querySelector('.aries-product>.grid-product-item').querySelectorAll('.toggle-item').forEach(item => {
    item.addEventListener('click', (e)=>{
      e.stopPropagation();
      e.preventDefault();
      const toggle_color = $(item).data('color');
      let index = 0;
      switch(toggle_color){
        case 'noproblemo': index = 0; break;
        case 'alien': index = 1; break;
        case 'credit-card': index = 2; break;
      }
      swiper_s6.slideToLoop(index,1000,false);
    })
  });
  function toggleFAQ(id) {
      const content = document.getElementById(id);
      const icon = document.getElementById(id + '-icon');

      if (content.style.maxHeight) {
        content.style.maxHeight = null;
        icon.classList.remove('rotate-180');
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        icon.classList.add('rotate-180');
      }
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-friday-2024"]) return;
  try {
    
  class Countdown {
    constructor(el) {
      this.el = el;
      this.targetDate = new Date(el.getAttribute("date-time"));
      this.createCountDownParts()
      this.countdownFunction();
      this.countdownLoopId = setInterval(this.countdownFunction.bind(this), 1000)
    }
    createCountDownParts() {
      ["days", "hours", "minutes", "seconds"].forEach(part => {
        const wrapperEl = document.createElement("div");
        wrapperEl.classList.add("w-full", "aspect-w-11", "aspect-h-12");

        const partEl = document.createElement("div");
        partEl.classList.add("part", "w-full", "h-full", part);

        const textEl = document.createElement("div");
        textEl.classList.add("text");
        textEl.innerText = part;

        const numberEl = document.createElement("div");
        numberEl.classList.add("number");
        numberEl.innerText = 0;

        partEl.append(numberEl, textEl);
        wrapperEl.append(partEl);
        this.el.append(wrapperEl);

        this[part] = numberEl;
      })
    }
    countdownFunction() {
      const remaining = this.getTimes(this.targetDate);
      Object.entries(remaining).forEach(([part, value]) => {
        this[part].style.setProperty("--value", value)
        this[part].innerText = value
      })
    }
    getTimes = (time) => {
      const t = new Date(time).getTime();
      const offset = new Date().getTimezoneOffset() * 60 * 1000;
      const offsetTime = t - offset;
      return this.getPart(offsetTime);
    }
    getPart(endTime) {
      const current = Math.floor(Date.now() / 1000);
      let diff = Math.floor(endTime / 1000) - current;
      if (diff > 0) {
        let d = Math.floor(diff / (3600 * 24));
        let h = Math.floor((diff % (3600 * 24)) / (60 * 60));
        let m = Math.floor(((diff % (3600 * 24)) % (60 * 60)) / 60);
        let s = Math.floor(diff % 60);
        let days = d < 10 ? "0" + d : d;
        let hours = h < 10 ? "0" + h : h;
        let minutes = m < 10 ? "0" + m : m;
        let seconds = s < 10 ? "0" + s : s;
        return { days, hours, minutes, seconds }
      }
    }
  }
  const countdownEls = document.querySelectorAll(".countdown") || [];
  if (countdownEls.length > 0) {
    countdownEls.forEach(countdownEl => new Countdown(countdownEl));
  }
  let scrollX,scrollY,scrollDirection;
  function getScrollAction() {
    if (typeof scrollX == 'undefined') {
      scrollX = window.pageXOffset;
      scrollY = window.pageYOffset;
      scrollDirection = 'down';
    }
    var diffX = scrollX - window.pageXOffset;
    var diffY = scrollY - window.pageYOffset;

    if (diffX < 0) {
      // Scroll right
      scrollDirection = 'right';
    } else if (diffX > 0) {
      // Scroll left
      scrollDirection = 'left';
    } else if (diffY < 0) {
      // Scroll down
      scrollDirection = 'down';
    } else if (diffY > 0) {
      // Scroll up
      scrollDirection = 'up';
    }
    scrollX = window.pageXOffset;
    scrollY = window.pageYOffset;
  }
  var Sticky_Anchor = new hcSticky('.anchor-points', {
    stickTo: '#sticky_container',
    bottomEnd: 112,
    onStart: function(){
      const h_header = $('.header-wrapper').height();
      const h_shop = $('#sticky_container').offset().top;
      window.onscroll = function (e) {
        getScrollAction();
        if (scrollY > h_shop) {
          $('#sticky_container>.anchor-points').css('position', 'fixed');
          if (scrollDirection  == 'up') {
            $('#sticky_container>.anchor-points').css('top', h_header);
          }else{
            $('#sticky_container>.anchor-points').css('top', 0);
          }
        }else{
          $('#sticky_container>.anchor-points').css('position', 'static');
        }
      }
    }
  });
  setTimeout(function(){
    Sticky_Anchor.refresh();
  },3000);
  $(function () {
    const anchorPoints = $('#sticky_container>.anchor-points a'); // Select all anchor links
    const sections = Array.from(document.querySelectorAll('.content-section')); // Only include content sections
  
    // Click Event: Smooth Scroll and Active Class Management
    anchorPoints.on('click', function (e) {
      e.preventDefault();
      const targetId = $(this).data('target');
  
      // Remove the 'active' class from all anchor items
      anchorPoints.removeClass('active');
  
      // Add the 'active' class to the clicked anchor
      $(this).addClass('active');
  
      // Smooth scroll to the target section
      window.scrollTo({
        top: $(targetId).offset().top - 96, // Adjust offset for sticky menu
        behavior: 'smooth',
      });
    });
  
    // Scroll Event: Dynamic Active Class Management
    $(window).on('scroll', function () {
      let currentSection = '';
  
      // Determine the currently visible section
      sections.forEach((section) => {
        const sectionTop = section.offsetTop - 96; // Adjust for sticky menu height
        const sectionBottom = sectionTop + section.offsetHeight;
  
        // Check if the current scroll position is within the section's bounds
        if (window.pageYOffset >= sectionTop && window.pageYOffset < sectionBottom) {
          currentSection = `#${section.id}`;
        }
      });
  
      // Update the active class based on the current section
      anchorPoints.each(function () {
        const target = $(this).data('target');
        if (target === currentSection) {
          $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
      });
    });

    $('.shopBtn').click(function(){
      $(this).closest('.grid-container').find('.grid-product-item').find('.form_btn-open').click();
    })
  });

  var swiper_s5 = new Swiper('#swiper_s5',{
    slidesPerView: 1,
    watchOverflow: true,
    spaceBetween: 32,
    // autoHeight: true,
    grid: {
      fill: 'row',
      rows: 1,
    },
    breakpoints:{
      1024:{
        slidesPerView: 1,
        grid: {
          fill: 'row',
          rows: 3,
        },
      }
    },
    pagination: {
      el: '#pagination_s5',
      clickable: true,
      renderBullet: function (index, className) {
        switch(index){
          case 0: text = 'Phone Cases'; break;
          case 1: text = 'Watch Cases & Bands'; break;
          case 2: text = 'iPad Cases & Accessories'; break;
        }
        return '<div class="' + className + '"><span class="text-size-12 xs:text-size-14 sm:text-size-16 xl:text-size-18">' + text + '</span></div>';
      }
    }
  })
  // if (window.innerWidth >= 1024) {
  //   swiper_s5.disable()
  // }else{
  //   swiper_s5.enable()
  //   setTimeout(() => {
  //     swiper_s5.update();
  //   }, 3000);
  // }
  var swiper_s6 = new Swiper('#swiper_s6', {
    loop: true,
    spaceBetween: 8,
    // autoplay:true,
    speed: 1000,
    // simulateTouch: false,
    // allowTouchMove: false,
    on: {
      init:function(){
        this.emit('transitionEnd');
      },
      transitionEnd: function () {
        const index = this.realIndex;
        switch(index){
          case 0: text = 'noproblemo'; break;
          case 1: text = 'alien'; break;
          case 2: text = 'credit-card'; break;
        }
        $('.aries-product>.grid-product-item').find(`.toggle-item[data-color=${text}]`).trigger('click');
      }
    }
  });
  var swiper_s7 = new Swiper('#swiper_s7', {
    rewind: true,
    allowTouchMove: false,
    autoHeight: true,
    spaceBetween: 8,
    pagination: {
      el: '#pagination_s7',
      clickable: true,
      renderBullet: function (index, className) {
        switch(index){
          case 0: text = 'Phone Cases'; break;
          case 1: text = 'Watch Cases & Bands'; break;
          case 2: text = 'iPad Cases & Accessories'; break;
          case 3: text = 'Car Mount'; break;
        }
        return '<div class="' + className + '"><span class="text-size-12 xs:text-size-14 sm:text-size-16 xl:text-size-18">' + text + '</span></div>';
      }
    }
  });
  
  document.querySelector('.aries-product>.grid-product-item').querySelectorAll('.toggle-item').forEach(item => {
    item.addEventListener('click', (e)=>{
      e.stopPropagation();
      e.preventDefault();
      const toggle_color = $(item).data('color');
      let index = 0;
      switch(toggle_color){
        case 'noproblemo': index = 0; break;
        case 'alien': index = 1; break;
        case 'credit-card': index = 2; break;
      }
      swiper_s6.slideToLoop(index,1000,false);
    })
  });
  function toggleFAQ(id) {
      const content = document.getElementById(id);
      const icon = document.getElementById(id + '-icon');

      if (content.style.maxHeight) {
        content.style.maxHeight = null;
        icon.classList.remove('rotate-180');
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        icon.classList.add('rotate-180');
      }
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["christmas-2024-template"]) return;
  try {
    
  let scrollX,scrollY,scrollDirection;
  function getScrollAction() {
    if (typeof scrollX == 'undefined') {
      scrollX = window.pageXOffset;
      scrollY = window.pageYOffset;
      scrollDirection = 'down';
    }
    var diffX = scrollX - window.pageXOffset;
    var diffY = scrollY - window.pageYOffset;

    if (diffX < 0) {
      // Scroll right
      scrollDirection = 'right';
    } else if (diffX > 0) {
      // Scroll left
      scrollDirection = 'left';
    } else if (diffY < 0) {
      // Scroll down
      scrollDirection = 'down';
    } else if (diffY > 0) {
      // Scroll up
      scrollDirection = 'up';
    }
    scrollX = window.pageXOffset;
    scrollY = window.pageYOffset;
  }
  var Sticky_Anchor = new hcSticky('.anchor-points', {
    stickTo: '#sticky_container',
    bottomEnd: 112,
    onStart: function(){
      const h_header = $('.header-wrapper').height();
      const h_shop = $('#sticky_container').offset().top;
      window.onscroll = function (e) {
        getScrollAction();
        if (scrollY > h_shop) {
          $('#sticky_container>.anchor-points').css('position', 'fixed');
          if (scrollDirection  == 'up') {
            $('#sticky_container>.anchor-points').css('top', h_header);
          }else{
            $('#sticky_container>.anchor-points').css('top', 0);
          }
        }else{
          $('#sticky_container>.anchor-points').css('position', 'relative');
        }
      }
    }
  });
  setTimeout(function(){
    Sticky_Anchor.refresh();
  },3000);
  $(function(){
    $('#toggle_open').click(function () {
      $('#toggle_box').slideToggle('slow');
    });
    const anchorPointsH = $('#sticky_container>.anchor-points').height();
    $('#sticky_container>.anchor-points').on('click', '.anchor-point', function (e) {
      e.preventDefault();
      $(this).addClass('active').parent().siblings().find('.anchor-point').removeClass('active');
      let _anchorPoints = Array.from(document.querySelector("#sticky_container>.anchor-points").querySelectorAll("a[data-target^='#']"));

      const targetId = $(this).data('target');
      window.scrollTo({
        top: $(targetId).offset().top - 96,
        behavior: "smooth"
      });
    });

    $('.shopBtn').click(function(){
      $(this).closest('.grid-container').find('.grid-product-item').find('.form_btn-open').click();
    })

    let points_wrapper = document.querySelector('.anchor-points>div');
    $('.anchor-btn-prev').on('click', function (e) {
      const points_left = points_wrapper.scrollLeft;
      console.log(points_left)
      points_wrapper.scrollLeft = points_left < 120 ? 0 : (points_left - 120);
    })
    $('.anchor-btn-next').on('click', function (e) {
      const points_left = points_wrapper.scrollLeft;
      const wrapper_end = points_wrapper.innerWidth - document.querySelector('.anchor-points').innerWidth;
      // console.log(points_left)
      points_wrapper.scrollLeft = points_left > (wrapper_end - 120) ? wrapper_end : (points_left + 120);
    })
  })

  var swiper_points = new Swiper('#swiper_points', {
    slidesPerView: 2.5,
    spaceBetween: 28,
    breakpoints: {
      768: {
        slidesPerView: 3.8,
      },
      1024: {
        slidesPerView: 4.2,
      },
      1280: {
        slidesPerView: 4.6,
      },
      1760: {
        slidesPerView: 4.8,
      },
      1920: {
        slidesPerView: 5.2,
      }
    },
    navigation: {
      nextEl: '#button_next_points',
      prevEl: '#button_prev_points'
    },
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    $('.accordion-footer_nav .item').on('click', '.title', function () {
      $(this).toggleClass('active');
      $(this).next('.content').slideToggle();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-template"]) return;
  try {
    
  let scrollX,scrollY,scrollDirection;
  function getScrollAction() {
    if (typeof scrollX == 'undefined') {
      scrollX = window.pageXOffset;
      scrollY = window.pageYOffset;
      scrollDirection = 'down';
    }
    var diffX = scrollX - window.pageXOffset;
    var diffY = scrollY - window.pageYOffset;

    if (diffX < 0) {
      // Scroll right
      scrollDirection = 'right';
    } else if (diffX > 0) {
      // Scroll left
      scrollDirection = 'left';
    } else if (diffY < 0) {
      // Scroll down
      scrollDirection = 'down';
    } else if (diffY > 0) {
      // Scroll up
      scrollDirection = 'up';
    }
    scrollX = window.pageXOffset;
    scrollY = window.pageYOffset;
  }
  var Sticky_Anchor = new hcSticky('.anchor-points', {
    stickTo: '#sticky_container',
    bottomEnd: 112,
    onStart: function(){
      const h_header = $('.header-wrapper').height();
      const h_shop = $('#sticky_container').offset().top;
      window.onscroll = function (e) {
        getScrollAction();
        if (scrollY > h_shop) {
          $('#sticky_container>.anchor-points').css('position', 'fixed');
          if (scrollDirection  == 'up') {
            $('#sticky_container>.anchor-points').css('top', h_header);
          }else{
            $('#sticky_container>.anchor-points').css('top', 0);
          }
        }else{
          $('#sticky_container>.anchor-points').css('position', 'static');
        }
      }
    }
  });
  setTimeout(function(){
    Sticky_Anchor.refresh();
  },3000);
  $(function(){
    const anchorPointsH = $('#sticky_container>.anchor-points').height();
    $('#sticky_container>.anchor-points').on('click', 'a', function (e) {
      e.preventDefault();
      $(this).addClass('active').siblings().removeClass('active');
      let _anchorPoints = Array.from(document.querySelector("#sticky_container>.anchor-points").querySelectorAll("a[data-target^='#']"));

      const targetId = $(this).data('target');
      window.scrollTo({
        top: $(targetId).offset().top - 96,
        behavior: "smooth"
      });
    });

    $('.shopBtn').click(function(){
      $(this).parent().siblings('.grid-product-item').find('.form_btn-open').click();
    })
  })

  const color_list = $('#color_list').html().trim().split(',');
  var swiper_s21 = new Swiper('#swiper_s21', {
    speed: 1000,
    pagination: {
      el: '#pagination_s21',
      clickable: true,
      renderBullet: function (index, className) {
        const color_src = color_list[index];
        return `<div class="${className}"><img src=${color_src} class="block w-full h-full object-cover rounded-full"></div>`;
      }
    },
    navigation: {
      nextEl: '#button_next_s21',
      prevEl: '#button_prev_s21'
    }
  })

  var swiper_s22 = new Swiper('#swiper_s22', {
    slidesPerView: 2.2,
    spaceBetween: 8,
    speed: 1000,
    watchOverflow: true,
    breakpoints: {
      768:{
        slidesPerView: 3,
        spaceBetween: 12
      },
      1024:{
        slidesPerView: 3,
        spaceBetween: 16
      },
      1280:{
        slidesPerView: 3,
        spaceBetween: 24
      },
      1760:{
        slidesPerView: 3,
        spaceBetween: 32
      },
      1920:{
        slidesPerView: 3,
        spaceBetween: 40
      }
    }
  })

  var swiper_s3 = new Swiper('#swiper_s3', {
    rewind: true,
    allowTouchMove: false,
    autoHeight: true,
    spaceBetween: 8,
    pagination: {
      el: '#pagination_s3',
      clickable: true,
      renderBullet: function (index, className) {
        switch(index){
          case 0: text = 'iPhone Cases'; break;
          case 1: text = 'Samsung Cases'; break;
          case 2: text = 'Google Cases'; break;
        }
        return '<div class="' + className + '"><span class="text-size-12 xs:text-size-14 sm:text-size-16 xl:text-size-18">' + text + '</span></div>';
      }
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-original"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1280px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      //console.log(scrollTop);
      //if (scrollTop < parseInt(window.innerHeight / 2) && scrollTop > 0 ) return;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      //this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  let siteHeaderWrapper = document.querySelector('header.site-header');
  document.querySelectorAll('[id^="Details-"] .header__menu-item').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.parentNode.removeAttribute('open');
    summary.setAttribute('aria-expanded', false);

    if(summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }
    
    summary.addEventListener('click touchend', (event) => {
      let detailsElement = event.currentTarget.parentNode;
      const openDetailsFlag = detailsElement.hasAttribute('open');
      // console.log(detailsElement);
      // console.log(openDetailsFlag);
      if (openDetailsFlag) {
        detailsElement.removeAttribute('open');
        siteHeaderWrapper.classList.remove('nav-open');
      }else{
        detailsElement.setAttribute('open','');
        siteHeaderWrapper.classList.add('nav-open');
      };
      event.currentTarget.setAttribute('aria-expanded', openDetailsFlag ? 'false' : 'true');
    }, false);

    summary.addEventListener('mouseover', (event) => {
      document.querySelectorAll('[id^="Details-HeaderMenu"]').forEach(details => {
        if (details.hasAttribute('open')) {
          const menuItem = details.querySelector('.header__menu-item');
          if (menuItem) menuItem.setAttribute('aria-expanded', 'false');
          details.removeAttribute('open');
        }
      });
      event.currentTarget.setAttribute('aria-expanded', 'true');
      event.currentTarget.parentNode.setAttribute('open', '');
      siteHeaderWrapper.classList.add('nav-open');
    }, true);

    summary.nextElementSibling.firstElementChild.addEventListener('mouseover', () => {
      summary.setAttribute('aria-expanded', true);
      summary.parentNode.setAttribute("open","");
      siteHeaderWrapper.classList.add('nav-open');
    }, true)

    summary.nextElementSibling.firstElementChild.addEventListener('mouseout', () => {
      summary.setAttribute('aria-expanded', false);
      summary.parentNode.removeAttribute("open");
      siteHeaderWrapper.classList.remove('nav-open');
    },true)
  });

  // window.onscroll = function(){
  //   var t = document.documentElement.scrollTop || document.body.scrollTop;
  //   const footer_t = document.querySelector('.footer-section').scrollTop;
  //   if(t >= 60){
  //     document.querySelectorAll('[id^="Details-"]').forEach(details => {
  //       details.querySelector('.header__menu-item').setAttribute('aria-expanded', false);
  //       details.removeAttribute('open');
  //       siteHeaderWrapper.classList.remove('nav-open');
  //     })
  //   }
  // }

  $(document).click(function (e) {
    var _con1 = $('[id^="MegaMenu-Content-"] .mega-menu__list');
    var _con2 = $('.site-header');
    const notTarget = !_con1.is(e.target) && _con1.has(e.target).length === 0 && !_con2.is(e.target) && _con2.has(e.target).length === 0;
    if (notTarget) {
      var $details = _con1.closest('.mega-menu');
      $details.removeAttr('open');
      $details.find('.header__menu-item').attr('aria-expanded', false);
      siteHeaderWrapper.classList.remove('nav-open');
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-center-compatibility"]) return;
  try {
    
  var data_compatibility = [{
    brand: 'Apple',
    name: 'MagEZ Case Pro 4 for iPhone 15 Series',
    handle: 'magez-case-pro-4-for-iphone-15',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: 'Compatible with iPhone 15 Pro Max and iPhone 15 Plus with case.'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'Yes, these two products are compatible.'
    }]
  }, {
    brand: 'Apple',
    name: 'MagEZ Case 4 for iPhone 15 Series',
    handle: 'magez-case-4-for-iphone-15',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: 'Compatible with iPhone 15 Pro Max and iPhone 15 Plus with case.'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'Yes, these two products are compatible.'
    }]
  }, {
    brand: 'Apple',
    name: 'MagEZ Case 3 for iPhone 14 Series',
    handle: 'magez-case-3-for-iphone-14',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: 'Yes, you can use the MagEZ Juice 2 to charge your iPhone 14 and 14 Plus. <br>But it’s not compatible with iPhone 14 Pro and Pro Max.'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: 'Yes, these two products are compatible. <br>Please note that the product slightly covers the camera lens of iPhone 14 Pro.'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Apple',
    name: 'MagEZ Case Pro 3 for iPhone 14 Series',
    handle: 'magez-case-pro-3-for-iphone-14',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: 'Yes, you can use the MagEZ Juice 2 to charge your iPhone 14 and 14 Plus. <br>But it’s not compatible with iPhone 14 Pro and Pro Max.'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: 'Yes, these two products are compatible. <br>Please note that the product slightly covers the camera lens of iPhone 14 Pro.'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Apple',
    name: 'MagEZ Case 2 for iPhone 13 Series',
    handle: 'magez-case-2-for-iphone-13',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Apple',
    name: 'MagEZ Case Pro 3 for iPhone 13 Series',
    handle: 'magez-case-pro-3-for-iphone-13',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Apple',
    name: 'Air Case for iPhone 13 Series',
    handle: 'air-case-for-iphone-13',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Apple',
    name: 'MagEZ Case for iPhone 12 Series',
    handle: 'magez-case-for-iphone-12',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: 'Yes, you can use the MagEZ Juice 2 to charge your iPhone 12 mini/12/12 Pro/12 Pro Max using a MagEZ Case. <br>MagEZ Juice 2 magnetically attaches to the iPhone 12 mini using a MagEZ Case, but due to the phone’s small size, it cannot slide out of the charging dock with the battery attached (needs to be removed from the dock separately).'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Apple',
    name: 'Air Case for iPhone 12 Series',
    handle: 'air-case-for-iphone-12',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Apple',
    name: 'MagEZ Case Pro 2 for iPhone 12 Series',
    handle: 'magez-case-pro-2-for-iphone-12',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: 'Yes, you can use the MagEZ Juice 2 to charge your iPhone 12 mini/12/12 Pro/12 Pro Max using a MagEZ Case. MagEZ Juice 2 magnetically attaches to the iPhone 12 mini using a MagEZ Case, but due to the phone’s small size, it cannot slide out of the charging dock with the battery attached (needs to be removed from the dock separately).'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Apple',
    name: 'MagEZ Case Pro for iPhone 11 Series',
    handle: 'magez-case-pro-for-iphone-11',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Apple',
    name: 'MagEZ Case for iPhone Xs/Xs Max/XR',
    handle: 'magez-case-for-iphone-xs',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Apple',
    name: 'MagEZ Case Pro for iPhone Xs/Xs Max/XR',
    handle: 'magez-case-pro-for-iphone-xs',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Apple',
    name: 'MagEZ Case for AirPods Pro',
    handle: 'magez-case-for-airpods-pro',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Apple',
    name: 'MagEZ Case for AirPods Pro 2',
    handle: 'magez-case-for-airpods-pro-2',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Apple',
    name: 'Air Pal',
    handle: 'air-pal',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Apple',
    name: 'Air Pal Mini',
    handle: 'air-pal-mini',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Samsung',
    name: 'MagEZ Case 4 for Samsung Galaxy S24 Series',
    handle: 'magez-case-4-for-samsung-galaxy-s24',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: 'Yes, they are compatible with magnetic attachment. <br>Please note the strong magnetic effect of this accessory affects S Pen’s handwriting operation, please remove it when writing.<br><span class="text-orange-500">*It slightly covers the camera lens area.</span>'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: 'Yes, they are compatible with magnetic wireless charging. <br>Please note the strong magnetic effect of this accessory affects S Pen’s handwriting operation, please remove it when writing.<br><span class="text-orange-500">*It slightly covers the camera lens area.</span>'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: 'Yes, they are compatible with magnetic wireless charging. <br>Please note the strong magnetic effect of this accessory affects S Pen’s handwriting operation, please remove it when writing.<br><span class="text-orange-500">*It slightly covers the camera lens area.</span>'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: 'Yes, they are Compatible with magnetic attachment, help to hold the phone firmly. <br>Please note the strong magnetic effect of this accessory affects S Pen’s handwriting operation, please remove it when writing.'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: 'Yes, these two products are compatible.<br>*It slightly covers the camera lens area of S24.'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'Yes, these two products are compatible.'
    }]
  }, {
    brand: 'Samsung',
    name: 'Air Case for Samsung Galaxy Z Fold5',
    handle: 'air-case-for-samsung-galaxy-z-fold5',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Samsung',
    name: 'MagEZ Case 3 for Samsung Galaxy Z Flip5',
    handle: 'magez-case-3-for-samsung-galaxy-z-flip5',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: 'Yes, these two products are compatible. <br>Please note that due to the special shape of Z Flip5, it may be difficult to hold while using it.'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: 'Yes, these two products are compatible. <br>Please note that due to the special shape of Z Flip5, it may be difficult to hold while using it.'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: 'Yes, these two products are compatible. <br>Please note that due to the special shape of Z Flip5, it may be difficult to hold while using it.'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: 'Yes, these two products are compatible. <br>Please note that due to the special shape of Z Flip5, it may be difficult to hold while using it.'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: 'Yes, these two products are compatible. <br>Please note that due to the special shape of Z Flip5, it may be difficult to hold while using it.'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: 'Yes, these two products are compatible. <br>Please note that due to the special shape of Z Flip5, it may be difficult to hold while using it.'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Google',
    name: 'MagEZ Case 3 for Google Pixel Fold',
    handle: 'magez-case-3-for-google-pixel-fold',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: '<span class="text-orange-500">No, the MagEZ Car Mount Pro may not charge the phone because of software incompatibility.</span><br>The MagEZ Car Mount Lite (no wireless charging function) works well with Google Pixel Fold with the MagEZ Case 3.'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: '<span class="text-orange-500">No, they are not compatible. The MagEZ Grip 2 will keep waking up the NFC function of the Google device.</span>'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Samsung',
    name: 'MagEZ Case 3 for Samsung Galaxy S23 Series',
    handle: 'magez-case-3-for-samsung-galaxy-s23',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: '<span class="block">Yes, they are compatible with magnetic wireless charging.</span><ul class="mt-4 font-medium space-y-1"><li>*The strong magnetic effect of this accessory affects S Pen’s handwriting operation, please remove it when writing.</li><li>*The battery pack may slightly cover the camera lens.</li><li>*It cannot slide out of the charging dock with the battery attached (needs to be removed from the dock separately).</li><li>If you prefer the smooth slide, we recommend you purchase the <a class="underline" href="/products/magez-slider" target="_blank">MagEZ Slider 2</a>.</li>'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: 'Yes, they are compatible with magnetic attachment. <br>Please note the strong magnetic effect of this accessory affects S Pen’s handwriting operation, please remove it when writing.<br><span class="text-orange-500">*It slightly covers the camera lens area.</span>'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: 'Yes, they are compatible with magnetic attachment. <br>Please note the strong magnetic effect of this accessory affects S Pen’s handwriting operation, please remove it when writing.<br><span class="text-orange-500">*It slightly covers the camera lens area.</span>'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: 'Yes, they are compatible with magnetic wireless charging. <br>Please note the strong magnetic effect of this accessory affects S Pen’s handwriting operation, please remove it when writing.<br><span class="text-orange-500">*It slightly covers the camera lens area.</span>'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: 'Yes, they are compatible with magnetic wireless charging. <br>Please note the strong magnetic effect of this accessory affects S Pen’s handwriting operation, please remove it when writing.<br><span class="text-orange-500">*It slightly covers the camera lens area.</span>'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: 'Yes, they are compatible with magnetic wireless charging. <br>Please note the strong magnetic effect of this accessory affects S Pen’s handwriting operation, please remove it when writing.'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: 'Yes, they are compatible with magnetic attachment. <br>Please note the strong magnetic effect of this accessory affects S Pen’s handwriting operation, please remove it when writing.'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Samsung',
    name: 'Air Case for Samsung Galaxy Z Fold4',
    handle: 'air-case-for-samsung-galaxy-z-fold4',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Samsung',
    name: 'MagEZ Case 3 for Samsung Galaxy Z Flip4',
    handle: 'magez-case-3-for-samsung-galaxy-z-flip4',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: 'Yes, these two products are compatible. <br>Please note that due to the special shape of Z Flip4, it may be difficult to hold while using it.'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: 'Yes, these two products are compatible. <br>Please note that due to the special shape of Z Flip4, it may be difficult to hold while using it.'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: 'Yes, these two products are compatible. <br>Please note that due to the special shape of Z Flip4, it may be difficult to hold while using it.'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: 'Yes, these two products are compatible. <br>Please note that due to the special shape of Z Flip4, it may be difficult to hold while using it.'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: 'Yes, these two products are compatible. <br>Please note that due to the special shape of Z Flip4, it may be difficult to hold while using it.'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: 'Yes, these two products are compatible. <br>Please note that due to the special shape of Z Flip4, it may be difficult to hold while using it.'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Samsung',
    name: 'MagEZ Case 2 for Samsung Galaxy S22 Series',
    handle: 'magez-case-2-for-samsung-galaxy-s22',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: '<span class="block">Yes, they are compatible with magnetic wireless charging. </span><ul class="mt-4 font-medium space-y-1"><li>*The strong magnetic effect of this accessory affects S Pen’s handwriting operation, please remove it when writing.</li><li>*The battery pack may slightly cover the camera lens.</li><li>*It cannot slide out of the charging dock with the battery attached (needs to be removed from the dock separately).</li><li>If you prefer the smooth slide, we recommend you purchase the <a class="underline" href="/products/magez-slider" target="_blank">MagEZ Slider 2</a>.</li>'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: 'Yes, they are compatible with magnetic attachment. <br>Please note the strong magnetic effect of this accessory affects S Pen’s handwriting operation, please remove it when writing.<br><span class="text-orange-500">*It slightly covers the camera lens area.</span>'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: 'Yes, they are compatible with magnetic attachment. <br>Please note the strong magnetic effect of this accessory affects S Pen’s handwriting operation, please remove it when writing.<br><span class="text-orange-500">*It slightly covers the camera lens area.</span>'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: 'Yes, they are compatible with magnetic attachment. <br>Please note the strong magnetic effect of this accessory affects S Pen’s handwriting operation, please remove it when writing.'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: 'Yes, they are compatible with magnetic attachment. <br>Please note the strong magnetic effect of this accessory affects S Pen’s handwriting operation, please remove it when writing.'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: 'Yes, they are compatible with magnetic attachment. <br>Please note the strong magnetic effect of this accessory affects S Pen’s handwriting operation, please remove it when writing.'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: 'Yes, they are compatible with magnetic attachment. <br>Please note the strong magnetic effect of this accessory affects S Pen’s handwriting operation, please remove it when writing.'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Samsung',
    name: 'Air Case for Samsung Galaxy S22 Series',
    handle: 'air-case-for-samsung-galaxy-s22',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Samsung',
    name: 'MagEZ Case for Samsung Galaxy S21 Series',
    handle: 'magez-case-for-samsung-galaxy-s21',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: 'Yes, these two products are compatible.<br><span class="text-orange-500">But the S21 Ultra is not compatible with Juice 2.</span>'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Samsung',
    name: 'Air Case for Samsung Galaxy S21 Series',
    handle: 'air-case-for-samsung-galaxy-s21',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Samsung',
    name: 'MagEZ Case for Samsung Galaxy S20 Series',
    handle: 'magez-case-for-samsung-galaxy-s20',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: 'Yes, these two products are compatible.<br><span class="text-orange-500">But the Ultra version is not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: 'Yes, these two products are compatible.<br><span class="text-orange-500">But the Ultra version is not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: 'Yes, these two products are compatible.<br><span class="text-orange-500">But the Ultra version is not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Samsung',
    name: 'Air Case for Samsung Galaxy S20 Series',
    handle: 'air-case-for-samsung-galaxy-s20',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Samsung',
    name: 'MagEZ Case for Samsung Galaxy Note20 Series',
    handle: 'magez-case-for-samsung-galaxy-note20',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: 'Yes, these two products are compatible.<br><span class="text-orange-500">But the Ultra version is not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: 'Yes, these two products are compatible.<br><span class="text-orange-500">But the Ultra version is not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: 'Yes, these two products are compatible.<br><span class="text-orange-500">But the Ultra version is not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  }, {
    brand: 'Samsung',
    name: 'Air Case for Samsung Galaxy Note20 Series',
    handle: 'air-case-for-samsung-galaxy-note20',
    data: [{
      name: 'MagEZ Mount',
      handle: 'magez-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi',
      handle: 'magez-mount-qi',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Mount Qi Desktop',
      handle: 'magez-mount-qi-desktop',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice',
      handle: 'magez-juice',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Juice 2',
      handle: 'magez-juice-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 1.0',
      handle: 'magez-card-sleeve-1',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 2.0',
      handle: 'magez-card-sleeve-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Card Sleeve 3.0',
      handle: 'magez-card-sleeve-3',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider',
      handle: 'magez-slider',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Slider 2',
      handle: 'magez-slider-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Car Mount Pro/Lite/Pro 2',
      handle: 'magez-car-mount',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip',
      handle: 'magez-grip',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'MagEZ Grip 2',
      handle: 'magez-grip-2',
      result: '<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    }, {
      name: 'Air Omni',
      handle: 'air-omni',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'Air Omni Lite',
      handle: 'air-omni-lite',
      result: 'Yes, these two products are compatible.'
    }, {
      name: 'MagEZ Stand',
      handle: 'magez-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }, {
      name: 'MagEZ Charging Stand',
      handle: 'magez-charging-stand',
      result: 'The Qi wireless charging base of the Stand wireless charges any Qi-enabled device (iPhone 7.5W/Android up to 15W/earbuds 5W).'
    }]
  },{
    brand:'Apple',
    name:'MagEZ Case Pro for iPad Pro 2022/2021',
    handle:'magez-case-pro-for-ipad-pro',
    data:[{
      name:'MagEZ Stand',
      handle:'magez-stand',
      result:'<span class="text-orange-500">No, we don’t recommend you use them together. Because this Stand is not wireless charging your iPad through the MagEZ Case Pro.</span>'
    },{
      name:'MagEZ Charging Stand',
      handle:'magez-charging-stand',
      result:'Yes, these two products are compatible.'
    },{
      name:'MagEZ Folio',
      handle:'magez-folio',
      result:'Yes, these two products are compatible.'
    },{
      name:'MagEZ Folio 2',
      handle:'magez-folio-2',
      result:'Yes, these two products are compatible.'
    },{
      name:'PitaFlow Charger',
      handle:'pitaflow-charger',
      result:'Yes, these two products are compatible.'
    },{
      name:'FlipBook Case',
      handle:'flipbook-case',
      result:'FlipBook works with Apple Magic Keyboard for iPad Pro 12.9 and 11 inches. <br>The iPad with this Case alone doesn’t work.'
    },{
      name:'Air Omni',
      handle:'air-omni',
      result:'<span class="text-orange-500">No, because your MagEZ Pro Case already has a Type-C charging port in your iPad. If you need to charge by Air Omni/Lite, please take the Type-c charging port from your iPad Pro, without removing the case.</span> <br>We recommend you use the PitaFlow Charger to wireless charge your iPad Pro directly.'
    },{
      name:'Air Omni Lite',
      handle:'air-omni-lite',
      result:'<span class="text-orange-500">No, because your MagEZ Pro Case already has a Type-C charging port in your iPad. If you need to charge by Air Omni/Lite, please take the Type-c charging port from your iPad Pro, without removing the case.</span> <br>We recommend you use the PitaFlow Charger to wireless charge your iPad Pro directly.'
    }]
  }, {
    brand:'Apple',
    name:'MagEZ Case Pro for iPad mini 6',
    handle:'magez-case-pro-for-ipad-mini-6',
    data:[{
      name:'MagEZ Stand',
      handle:'magez-stand',
      result:'<span class="text-orange-500">No, we don’t recommend you use them together. Because this Stand is not wireless charging your iPad through the MagEZ Case Pro.</span>'
    },{
      name:'MagEZ Charging Stand',
      handle:'magez-charging-stand',
      result:'Yes, these two products are compatible.'
    },{
      name:'MagEZ Folio',
      handle:'magez-folio',
      result:'Yes, these two products are compatible.'
    },{
      name:'MagEZ Folio 2',
      handle:'magez-folio-2',
      result:'Yes, these two products are compatible.'
    },{
      name:'PitaFlow Charger',
      handle:'pitaflow-charger',
      result:'Yes, these two products are compatible.'
    },{
      name:'FlipBook Case',
      handle:'flipbook-case',
      result:'FlipBook works with Apple Magic Keyboard for iPad Pro 12.9 and 11 inches. <br>The iPad with this Case alone doesn’t work.'
    },{
      name:'Air Omni',
      handle:'air-omni',
      result:'<span class="text-orange-500">No, because your MagEZ Pro Case already has a Type-C charging port in your iPad Mini 6.</span> <br>We recommend you use the PitaFlow Charger to wireless charge your iPad mini 6.'
    },{
      name:'Air Omni Lite',
      handle:'air-omni-lite',
      result:'<span class="text-orange-500">No, because your MagEZ Pro Case already has a Type-C charging port in your iPad Mini 6.</span> <br>We recommend you use the PitaFlow Charger to wireless charge your iPad mini 6.'
    }]
  }, {
    brand:'Apple',
    name:'MagEZ Case 2 for iPad Pro/Air',
    handle:'magez-case-2-for-ipad',
    data:[{
      name:'MagEZ Stand',
      handle:'magez-stand',
      result:'Yes, these two products are compatible.'
    },{
      name:'MagEZ Charging Stand',
      handle:'magez-charging-stand',
      result:'<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    },{
      name:'MagEZ Folio',
      handle:'magez-folio',
      result:'Yes, these two products are compatible.'
    },{
      name:'MagEZ Folio 2',
      handle:'magez-folio-2',
      result:'Yes, these two products are compatible.'
    },{
      name:'PitaFlow Charger',
      handle:'pitaflow-charger',
      result:'<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    },{
      name:'FlipBook Case',
      handle:'flipbook-case',
      result:'FlipBook works with Apple Magic Keyboard for iPad Pro 12.9 and 11 inches. <br>The iPad with this Case alone doesn’t work.'
    },{
      name:'Air Omni',
      handle:'air-omni',
      result:'Yes, they are compatible, the Type-c Toggle and Type-c charging port work with your iPad.'
    },{
      name:'Air Omni Lite',
      handle:'air-omni-lite',
      result:'Yes, they are compatible, the Type-c Toggle and Type-c charging port work with your iPad.'
    }]
  }, {
    brand:'Apple',
    name:'MagEZ Case for iPad Pro/Air',
    handle:'magez-case-for-ipad',
    data:[{
      name:'MagEZ Stand',
      handle:'magez-stand',
      result:'<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    },{
      name:'MagEZ Charging Stand',
      handle:'magez-charging-stand',
      result:'<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    },{
      name:'MagEZ Folio',
      handle:'magez-folio',
      result:'<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    },{
      name:'MagEZ Folio 2',
      handle:'magez-folio-2',
      result:'<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    },{
      name:'PitaFlow Charger',
      handle:'pitaflow-charger',
      result:'<span class="text-orange-500">Unfortunately, these two products are not compatible.</span>'
    },{
      name:'FlipBook Case',
      handle:'flipbook-case',
      result:'FlipBook works with Apple Magic Keyboard for iPad Pro 12.9 and 11 inches. <br>The iPad with this Case alone doesn’t work.'
    },{
      name:'Air Omni',
      handle:'air-omni',
      result:'Yes, they are compatible, the Type-c Toggle and Type-c charging port work with your iPad.'
    },{
      name:'Air Omni Lite',
      handle:'air-omni-lite',
      result:'Yes, they are compatible, the Type-c Toggle and Type-c charging port work with your iPad.'
    }]
  }];


  let select_case,select_accessory;
  $('.filter__toggle').on('click', function () {
    var $filterCon = $(this).parent('.filter__has-sublist');
    $filterCon.toggleClass('filter--expanded')
      .find('.filter__sublist').slideToggle(300);
    $filterCon.siblings().removeClass('filter--expanded')
      .find('.filter__sublist').slideUp(200);

    if ($(this).parent().hasClass('filter--expanded')) {
      $(this).children('.filter__toggle-button').attr('aria-expanded', true);
    } else {
      $(this).children('.filter__toggle-button').attr('aria-expanded', false);
    }

    $(document).click(function (e) {
      var _con_list = $filterCon.find('.filter__sublist');
      var _con_toggle = $filterCon.find('.filter__toggle');
      if (!_con_list.is(e.target) && _con_list.has(e.target).length === 0 && !_con_toggle.is(e.target) && _con_toggle.has(e.target).length === 0) {
        $filterCon.removeClass('filter--expanded');
        _con_list.slideUp(200);
      }
    })
  });

  $('.filter__sublist').on('click','.filter__sublink', function () {
    const $this = $(this);
    $this.parents('.filter__has-sublist').find('.filter__toggle').removeClass('border border-red-600');
    const filter_title = $this.find('span').html();
    const filter_value = $this.data('value');

    let $h4_link = $this.parents('.filter__has-sublist').find('.filter__link');
    $h4_link.html(filter_title).attr('data-value', filter_value);

    $this.parent().slideUp();
    $this.parents('.filter__has-sublist').removeClass('filter--expanded');
    $this.parent().prev().children('.filter__toggle-button').attr('aria-expanded', false);

    $this.closest('.filter__has-sublist').parent().next('.check-warning').addClass('hidden');

    const filter_name = $this.parent().attr('id');
    if (filter_name != 'filter_accessory_list' && filter_value != '0') {
      const $filter_wrapper = $this.parents('.filter__has-sublist');
      let firstName;
      if($filter_wrapper.index() == 0){
        firstName = filter_name.split('_')[1];
        let $secondList = $filter_wrapper.next().find('.filter__sublist');
        $secondList.find('li').hide();
        $secondList.find(`li.filter__sublink[data-${firstName}=${filter_value}]`).show();
      }else {
        let $firstList = $filter_wrapper.prev().find('.filter__sublist');
        firstName = $firstList.attr('id').split('_')[1];
        const filter_firstValue = $this.data(firstName);
        const first_title =  $firstList.find(`li.filter__sublink[data-value='${filter_firstValue}']`).find('span').html();
        $(`#filter_${firstName}`).find('h4.filter__link').html(first_title).attr('data-value',filter_firstValue);
      }
      select_case =  filter_value;
    }else if(filter_name == 'filter_accessory_list'){
      select_accessory =  filter_value;
    }
  });

  $('#checkBtn').click(function(){
    if(select_case == '0'){
      $('#filter_case').find('.filter__toggle').addClass('border border-red-600');
      $('#filter_case').parent().next('.check-warning').removeClass('hidden');
    }else if(select_accessory == '0'){
      $('#filter_accessory').find('.filter__toggle').addClass('border border-red-600');
      $('#filter_accessory').parent().next('.check-warning').removeClass('hidden');
    }else{
      const jsonObj_main = data_compatibility.filter(data => data.handle == select_case)[0];
      const jsonObj_secondary = jsonObj_main.data.filter(item => item.handle == select_accessory)[0];
      let compatibility_res = jsonObj_secondary ? jsonObj_secondary.result :'It is not available because the usage scenarios are different.';
      $('.check-result').removeClass('hidden').html(compatibility_res);
      // let res_html = compatibility_res;
      // if (compatibility_res.includes('Unforunately')) {
      //   res_html = `<span class="text-orange-500">${compatibility_res}</span>`;
      // }else if(compatibility_res.includes('But')){
      //   const res_red =  compatibility_res.split('But')[0];
      //   const res_black =  'But'+ compatibility_res.split('But')[1];
      //   res_html = `<span class="text-orange-500">${res_red}</span>${res_black}`;
      // }else if(compatibility_res.includes('Please note')){
      //   const res_black =  compatibility_res.split('Please note')[0];
      //   const res_red =  'Please note'+ compatibility_res.split('Please note')[1];
      //   res_html = `${res_black}<br><span class="text-orange-500">${res_red}</span>`;
      // }
      //$('.check-result').removeClass('hidden').html(res_html);
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-center-knowledge-base"]) return;
  try {
    
$(function () {
  $('.nav-item').click(function () {
    const nav_name = $(this).data('target');
    $(this).addClass('active').siblings().removeClass('active');
    $(`.content-item[data-name='${nav_name}']`).addClass('active').siblings().removeClass('active');
  });

  $('.faq-question').click(function () {
    $(this).parent('.faq-wrapper').toggleClass('open');
  })
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-center-select-product"]) return;
  try {
    
  const model_size = $('#product_models').find('span.model-item').length + 1;
  const rows_2 = Math.ceil(model_size / 2);
  const rows_3 = Math.ceil(model_size / 3);
  var swiper_products = new Swiper('#swiper_products', {
    slidesPerView: 2,
    spaceBetween: 12,
    watchOverflow: true,
    grid: {
      fill: 'row',
      rows: rows_2
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 16,
        grid: {
          fill: 'row',
          rows: rows_3
        }
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 16,
        grid: {
          fill: 'row',
          rows: 1
        }
      },
      1760: {
        slidesPerView: 3,
        spaceBetween: 24,
        grid: {
          fill: 'row',
          rows: 1
        }
      }
    },
    navigation: {
      nextEl: '#swiper_next_products',
      prevEl: '#swiper_prev_products'
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-center-troubleshooting"]) return;
  try {
    
  $(function () {
    $('.nav-item').click(function () {
      const nav_name = $(this).data('target');
      $(this).addClass('active').siblings().removeClass('active');
      $(`.content-item[data-name='${nav_name}']`).addClass('active').siblings().removeClass('active');
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    

  let urlParams = location.href;

  if(urlParams.includes('tagged')){
    let query_tag = urlParams.split('/tagged/')[1];
    let query_tag_topic = '', query_tag_product = '';

    if(query_tag.includes('+')){
      let query_tags = query_tag.split('+');
      for(let i = 0; i < query_tags.length; i++){
        if(query_tags[i].includes('topic-')){
          query_tag_topic = query_tags[i];
        }else if(query_tags[i].includes('products-')){
          query_tag_product = query_tags[i];
        }
      }
    }else{
      if(query_tag.includes('topic-')){
        query_tag_topic = query_tag;
      }else if(query_tag.includes('products-')){
        query_tag_product = query_tag;
      }
    }

    $("#filter-topic").find(".filter__link").attr('name', query_tag_topic);
    $("#filter-products").find(".filter__link").attr('name', query_tag_product);

    $("#filter-topic").find(".filter__sublink").each(function(){
      const data_name = $(this).data('name');
      const data_value = $(this).data('value');
      if(data_name == query_tag_topic){
        $("#filter-topic").find(".filter__link").html(data_value);
        $('#filter_topic').html(data_value);
      }
    })
    $("#filter-products").find(".filter__sublink").each(function(){
      const data_name = $(this).data('name');
      const data_value = $(this).data('value');
      if(data_name == query_tag_product){
        $("#filter-products").find(".filter__link").html(data_value);
        $('#filter_products').html(data_value);
      }
    })

  }

  $('.filter__toggle').on('click', function () {
    var $filterCon = $(this).parent('.filter__has-sublist');
    $filterCon.toggleClass('filter--expanded')
      .find('.filter__sublist').slideToggle(1000);
    $filterCon.siblings().removeClass('filter--expanded')
      .find('.filter__sublist').slideUp(1000);

    if (
      $(this).parent().hasClass('filter--expanded')
    ) {
      $(this)
        .children('.filter__toggle-button')
        .attr('aria-expanded', true);
    } else {
      $(this)
        .children('.filter__toggle-button')
        .attr('aria-expanded', false);
    }

    $(document).click(function (e) {
      var _con_list = $filterCon.find('.filter__sublist');
      var _con_toggle = $filterCon.find('.filter__toggle');
      if (!_con_list.is(e.target) && _con_list.has(e.target).length === 0 && !_con_toggle.is(e.target) && _con_toggle.has(e.target).length === 0) {
        $filterCon.removeClass('filter--expanded');
        _con_list.slideUp(1000);
      }
    })
  });

  $('.filter__sublink').on('click', function () {
    let filter_value = $(this).data('value');
    let filter_handle = $(this).data('name');

    let $h4_link = $(this).parents('.filter__has-sublist').find('.filter__link');
    $h4_link.html(filter_value);
    $h4_link.attr('name', filter_handle);

    $(this).parent().slideUp();
    $(this).parents('.filter__has-sublist').removeClass('filter--expanded');
    $(this).parent().prev().children('.filter__toggle-button').attr('aria-expanded', false);

    let list_id = $(this).closest('.filter__has-sublist').attr('id').replace('-','_');
    $(`#${list_id}`).html(filter_value);

    let filter_query_arr = [];
    $('.filter-list-container').find('.filter__has-sublist').each(function(){
      let filter_name = $(this).find('.filter__link').attr('name');
      if(filter_name != ''){
        filter_query_arr.push(filter_name);
      }
    });
    //console.log(filter_query_arr)

    let filter_query = filter_query_arr.join('+');
    if(filter_query_arr.length > 0){
      window.location.href = `/blogs/news/tagged/${filter_query}`;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["member-day-2024"]) return;
  try {
    
  class Countdown {
    constructor(el) {
      this.el = el;
      this.targetDate = new Date(el.getAttribute("date-time"));
      this.createCountDownParts()
      this.countdownFunction();
      this.countdownLoopId = setInterval(this.countdownFunction.bind(this), 1000)
    }
    createCountDownParts() {
      // ["days", "hours", "minutes", "seconds"].forEach(part => {
      ["hours", "minutes", "seconds"].forEach(part => {
        const wrapperEl = document.createElement("div");
        wrapperEl.classList.add("w-full", "aspect-w-10", "aspect-h-9");

        const partEl = document.createElement("div");
        partEl.classList.add("part", "w-full", "h-full", part);

        const textEl = document.createElement("div");
        textEl.classList.add("text");
        textEl.innerText = part;

        const numberEl = document.createElement("div");
        numberEl.classList.add("number");
        numberEl.innerText = 0;

        partEl.append(numberEl, textEl);
        wrapperEl.append(partEl);
        this.el.append(wrapperEl);

        this[part] = numberEl;
      })
    }

    countdownFunction() {
      const remaining = this.getTimes(this.targetDate);
      Object.entries(remaining).forEach(([part, value]) => {
        this[part].style.setProperty("--value", value)
        this[part].innerText = value
      })
    }

    getTimes = (time) => {
      const t = new Date(time).getTime();
      const offset = new Date().getTimezoneOffset() * 60 * 1000;
      const offsetTime = t - offset;
      return this.getPart(offsetTime);
    }

    getPart(endTime) {
      const current = Math.floor(Date.now() / 1000);
      let diff = Math.floor(endTime / 1000) - current;
      if (diff > 0) {
        let d = Math.floor(diff / (3600 * 24));
        let h = Math.floor((diff % (3600 * 24)) / (60 * 60));
        let m = Math.floor(((diff % (3600 * 24)) % (60 * 60)) / 60);
        let s = Math.floor(diff % 60);
        // let days = d < 10 ? "0" + d : d;
        h = d > 0 ? Math.floor(h + 24 * d) : h;
        let hours = h < 10 ? "0" + h : h;
        let minutes = m < 10 ? "0" + m : m;
        let seconds = s < 10 ? "0" + s : s;
        // return { days, hours, minutes, seconds }
        return { hours, minutes, seconds }
      }
    }
  }
  const countdownEls = document.querySelectorAll(".countdown") || [];
  if (countdownEls.length > 0) {
    countdownEls.forEach(countdownEl => new Countdown(countdownEl));
  }
  // var swiper_s2 = new Swiper('#swiper_s2', {
  //   rewind: true,
  //   freeMode: true,
  //   slidesPerView: 3,
  //   grid: {
  //     fill: 'row',
  //     rows: 2,
  //   },
  //   spaceBetween: 32,
  //   watchOverflow: true,
  //   breakpoints: {
  //     768: {
  //       spaceBetween: 64,
  //       slidesPerView: 4,
  //       grid: {
  //         fill: 'row',
  //         rows: 1,
  //       }
  //     },
  //     1024: {
  //       spaceBetween: 84,
  //       slidesPerView: 4,
  //       grid: {
  //         fill: 'row',
  //         rows: 1,
  //       }
  //     },
  //     1280: {
  //       spaceBetween: 100,
  //       slidesPerView: 4,
  //       grid: {
  //         fill: 'row',
  //         rows: 1,
  //       }
  //     },
  //     1760: {
  //       spaceBetween: 128,
  //       slidesPerView: 4,
  //       grid: {
  //         fill: 'row',
  //         rows: 1,
  //       }
  //     },
  //     1920: {
  //       spaceBetween: 160,
  //       slidesPerView: 4,
  //       grid: {
  //         fill: 'row',
  //         rows: 1,
  //       }
  //     }
  //   }
  // });
  var swiper_s4 = new Swiper('#swiper_s4', {
    rewind: true,
    spaceBetween: 8,
    slidesPerView: 1,
    watchOverflow: true,
    breakpoints: {
      1024: {
        spaceBetween: 0,
        slidesPerView: 5
      }
    },
    scrollbar: {
      el: '#scrollbar_s4',
      draggable: true
    }
  });
  if(window.innerWidth >= 1024){
    swiper_s4.disable();
  }
  $(function () {
    $('#toggle_open_1').click(function () {
      $('#toggle_box_1').slideToggle('slow');
      const spanHtml = $(this).find('span').html();
      if (spanHtml == '+') {
        $(this).find('span').html('-');
      }else{
        $(this).find('span').html('+');
      }
    });
    $('#toggle_open_2').click(function () {
      $('#toggle_box_2').slideToggle('slow');
    });
    $('.shopBtn').click(function(){
      $(this).closest('.grid-container').find('.grid-product-item').find('.form_btn-open').click();
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["member-day-2025"]) return;
  try {
    
  class Countdown {
    constructor(el) {
      this.el = el;
      this.targetDate = new Date(el.getAttribute("date-time"));
      this.createCountDownParts()
      this.countdownFunction();
      this.countdownLoopId = setInterval(this.countdownFunction.bind(this), 1000)
    }
    createCountDownParts() {
      // ["days", "hours", "minutes", "seconds"].forEach(part => {
      ["hours", "minutes", "seconds"].forEach(part => {
        const wrapperEl = document.createElement("div");
        wrapperEl.classList.add("w-full", "aspect-w-10", "aspect-h-9");

        const partEl = document.createElement("div");
        partEl.classList.add("part", "w-full", "h-full", part);

        const textEl = document.createElement("div");
        textEl.classList.add("text");
        textEl.innerText = part;

        const numberEl = document.createElement("div");
        numberEl.classList.add("number");
        numberEl.innerText = 0;

        partEl.append(numberEl, textEl);
        wrapperEl.append(partEl);
        this.el.append(wrapperEl);

        this[part] = numberEl;
      })
    }

    countdownFunction() {
      const remaining = this.getTimes(this.targetDate);
      Object.entries(remaining).forEach(([part, value]) => {
        this[part].style.setProperty("--value", value)
        this[part].innerText = value
      })
    }

    getTimes = (time) => {
      const t = new Date(time).getTime();
      const offset = new Date().getTimezoneOffset() * 60 * 1000;
      const offsetTime = t - offset;
      return this.getPart(offsetTime);
    }

    getPart(endTime) {
      const current = Math.floor(Date.now() / 1000);
      let diff = Math.floor(endTime / 1000) - current;
      if (diff > 0) {
        let d = Math.floor(diff / (3600 * 24));
        let h = Math.floor((diff % (3600 * 24)) / (60 * 60));
        let m = Math.floor(((diff % (3600 * 24)) % (60 * 60)) / 60);
        let s = Math.floor(diff % 60);
        // let days = d < 10 ? "0" + d : d;
        h = d > 0 ? Math.floor(h + 24 * d) : h;
        let hours = h < 10 ? "0" + h : h;
        let minutes = m < 10 ? "0" + m : m;
        let seconds = s < 10 ? "0" + s : s;
        // return { days, hours, minutes, seconds }
        return { hours, minutes, seconds }
      }
    }
  }
  const countdownEls = document.querySelectorAll(".countdown") || [];
  if (countdownEls.length > 0) {
    countdownEls.forEach(countdownEl => new Countdown(countdownEl));
  }
  var swiper_sep_s2 = new Swiper('#swiper_sep_s2', {
    slidesPerView: 2,
    spaceBetween: 12,
    watchOverflow: true,
    touchRatio : 0.8,
    nested: true,
    noSwiping: true,
    observer: true,
    observeParents: true,
    edgeSwipeDetection : true,
    edgeSwipeThreshold : 50, 
    passiveListeners : false,
    noSwipingSelector: 'button',
    grid: {
      fill: 'row',
      rows: 3
    },
    breakpoints: {
      768: {
        spaceBetween: 20,
        slidesPerView: 2,
        grid: {
          fill: 'row',
          rows: 1
        }
      },
      1024: {
        spaceBetween: 20,
        slidesPerView: 4,
        grid: {
          fill: 'row',
          rows: 1
        }
      },
      1440: {
        spaceBetween: 24,
        slidesPerView: 4,
        grid: {
          fill: 'row',
          rows: 1
        }
      },
      1920: {
        spaceBetween: 32,
        slidesPerView: 4,
        grid: {
          fill: 'row',
          rows: 1
        }
      }
    },
    navigation: {
      nextEl: '#button_next_sep_s2',
      prevEl: '#button_prev_sep_s2'
    }
  });

  var swiper_s4 = new Swiper('#swiper_s4', {
    rewind: true,
    spaceBetween: 8,
    slidesPerView: 1,
    watchOverflow: true,
    breakpoints: {
      1024: {
        spaceBetween: 0,
        slidesPerView: 5
      }
    },
    scrollbar: {
      el: '#scrollbar_s4',
      draggable: true
    }
  });
  if(window.innerWidth >= 1024){
    swiper_s4.disable();
  }
  $(function () {
    $('#toggle_open_1').click(function () {
      $('#toggle_box_1').slideToggle('slow');
      const spanHtml = $(this).find('span').html();
      if (spanHtml == '+') {
        $(this).find('span').html('-');
      }else{
        $(this).find('span').html('+');
      }
    });
    $('#toggle_open_2').click(function () {
      $('#toggle_box_2').slideToggle('slow');
    });
    $('.shopBtn').click(function(){
      $(this).closest('.grid-container').find('.grid-product-item').find('.form_btn-open').click();
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["member-day-2026"]) return;
  try {
    
  class Countdown {
    constructor(el) {
      this.el = el;
      this.targetDate = new Date(el.getAttribute("date-time"));
      this.createCountDownParts()
      this.countdownFunction();
      this.countdownLoopId = setInterval(this.countdownFunction.bind(this), 1000)
    }
    createCountDownParts() {
      // ["days", "hours", "minutes", "seconds"].forEach(part => {
      ["hours", "minutes", "seconds"].forEach(part => {
        const wrapperEl = document.createElement("div");
        wrapperEl.classList.add("w-full", "aspect-w-10", "aspect-h-9");

        const partEl = document.createElement("div");
        partEl.classList.add("part", "w-full", "h-full", part);

        const textEl = document.createElement("div");
        textEl.classList.add("text");
        textEl.innerText = part;

        const numberEl = document.createElement("div");
        numberEl.classList.add("number");
        numberEl.innerText = 0;

        partEl.append(numberEl, textEl);
        wrapperEl.append(partEl);
        this.el.append(wrapperEl);

        this[part] = numberEl;
      })
    }

    countdownFunction() {
      const remaining = this.getTimes(this.targetDate);
      Object.entries(remaining).forEach(([part, value]) => {
        this[part].style.setProperty("--value", value)
        this[part].innerText = value
      })
    }

    getTimes = (time) => {
      const t = new Date(time).getTime();
      const offset = new Date().getTimezoneOffset() * 60 * 1000;
      const offsetTime = t - offset;
      return this.getPart(offsetTime);
    }

    getPart(endTime) {
      const current = Math.floor(Date.now() / 1000);
      let diff = Math.floor(endTime / 1000) - current;
      if (diff > 0) {
        let d = Math.floor(diff / (3600 * 24));
        let h = Math.floor((diff % (3600 * 24)) / (60 * 60));
        let m = Math.floor(((diff % (3600 * 24)) % (60 * 60)) / 60);
        let s = Math.floor(diff % 60);
        // let days = d < 10 ? "0" + d : d;
        h = d > 0 ? Math.floor(h + 24 * d) : h;
        let hours = h < 10 ? "0" + h : h;
        let minutes = m < 10 ? "0" + m : m;
        let seconds = s < 10 ? "0" + s : s;
        // return { days, hours, minutes, seconds }
        return { hours, minutes, seconds }
      }
    }
  }
  const countdownEls = document.querySelectorAll(".countdown") || [];
  if (countdownEls.length > 0) {
    countdownEls.forEach(countdownEl => new Countdown(countdownEl));
  }
  var swiper_s2 = new Swiper('#swiper_s2', {
    slidesPerView: 2,
    spaceBetween: 12,
    watchOverflow: true,
    touchRatio : 0.8,
    nested: true,
    noSwiping: true,
    observer: true,
    observeParents: true,
    edgeSwipeDetection : true,
    edgeSwipeThreshold : 50, 
    passiveListeners : false,
    noSwipingSelector: 'button',
    grid: {
      fill: 'row',
      rows: 3
    },
    breakpoints: {
      768: {
        spaceBetween: 20,
        slidesPerView: 2,
        grid: {
          fill: 'row',
          rows: 1
        }
      },
      1024: {
        spaceBetween: 20,
        slidesPerView: 4,
        grid: {
          fill: 'row',
          rows: 1
        }
      },
      1440: {
        spaceBetween: 24,
        slidesPerView: 4,
        grid: {
          fill: 'row',
          rows: 1
        }
      },
      1920: {
        spaceBetween: 32,
        slidesPerView: 4,
        grid: {
          fill: 'row',
          rows: 1
        }
      }
    },
    navigation: {
      nextEl: '#button_next_s2',
      prevEl: '#button_prev_s2'
    }
  });

  var swiper_s4 = new Swiper('#swiper_s4', {
    rewind: true,
    spaceBetween: 8,
    slidesPerView: 1,
    watchOverflow: true,
    breakpoints: {
      1024: {
        spaceBetween: 0,
        slidesPerView: 5
      }
    },
    scrollbar: {
      el: '#scrollbar_s4',
      draggable: true
    }
  });
  if(window.innerWidth >= 1024){
    swiper_s4.disable();
  }
  $(function () {
    $('#toggle_open_1').click(function () {
      $('#toggle_box_1').slideToggle('slow');
      const spanHtml = $(this).find('span').html();
      if (spanHtml == '+') {
        $(this).find('span').html('-');
      }else{
        $(this).find('span').html('+');
      }
    });
    $('#toggle_open_2').click(function () {
      $('#toggle_box_2').slideToggle('slow');
    });
    $('.shopBtn').click(function(){
      $(this).closest('.grid-container').find('.grid-product-item').find('.form_btn-open').click();
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pitaka-sale-2025"]) return;
  try {
    
  let Sticky_s3 = new hcSticky('.navBox', {
    stickTo: '.section-list',
    onStart: function () {
      const rect = document.querySelector('.site-header').getBoundingClientRect();
      let heardHight = rect.height
      $('.navBox').css({
        transform: `translateY(-${heardHight}px)`
      })
    },
    onStop: function () {
      $('.navBox').css({
        transform: 'none'
      })
    },
  });
  var swiper_collection = {};
  function initSwiper(num) {
    const swiper_id = $(`.swiper_list_${num}`).attr('id');
    // console.log(swiper_id)
    swiper_collection[num + 'th'] = new Swiper(`.swiper_list_${num}`, {
      slidesPerView: 2,
      spaceBetween: 5,
      watchOverflow: true,
      grid:{
        fill: "row",
        rows: 4
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 10,
          grid:{
            fill: "row",
            rows: 1
          }
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 10,
          grid:{
            fill: "row",
            rows: 1
          }
        }
      },
      navigation: {
        nextEl: `.collection-item-swiper_${num} .swiper-button-next`,
        prevEl: `.collection-item-swiper_${num} .swiper-button-prev`,
      },
      scrollbar: {
        el: `.collection-item-swiper_${num} .swiper-scrollbar`,
        draggable: true
      }
    })
  }

  for (let index = 0; index < 8; index++) {
    initSwiper(index);
  }

  function initNav() {
    var navSwiper = new Swiper('#nav', {
      slidesPerView: 2.1,
      touchRatio : 0.8,
      slidesPerView: 1.5,
      spaceBetween: 12,
      nested: true,
      noSwiping: true,
      observer: true,
      observeParents: true,
      edgeSwipeDetection : true,
      edgeSwipeThreshold : 50, 
      passiveListeners : false,
      a11y: false,
      noSwipingSelector:'a',
      navigation: {
        nextEl: '.swiper-button-next-nav',
      },
      breakpoints: {
        768: {
          slidesPerView: 4
        },
        1280: {
          slidesPerView: 5
        },
      }
    })
  }
  initNav()

  if (window.location.href.includes('myshopify')) {
    let timer;
    timer = setInterval(() => {
      if ($('#nav').hasClass('swiper-initialized')) {
      } else {
        initNav();
      }

      for (let index = 0; index < 8; index++) {
        if (!$(`.swiper_list_${index}`).hasClass('swiper-initialized')) {
          initSwiper(index);
        }
      }
    }, 300)

    window.addEventListener('unload', () => {
      // console.log('页面已卸载');
      timer.clearInterval()
      timer = null;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-comparison"]) return;
  try {
    
    $(function(){
      $('#toggle_btn').click(function(){
        const table_expanded = $('.compare-table').hasClass('expand');
        const btn_html = table_expanded ? 'View more information' : 'View less information';   
        $(this).html(btn_html);
        $('.compare-table>div.last').toggleClass('hidden').toggleClass('grid');
      })
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-customize"]) return;
  try {
    
  const swiper_id = '#' + $('product-details-customize').find('.swiper').attr('id');
  const button_prev_id = '#' + $('product-details-customize').find('.swiper-button-prev').attr('id');
  const button_next_id = '#' + $('product-details-customize').find('.swiper-button-next').attr('id');
  if ($('product-details-customize').find('.swiper-scrollbar').length > 0) {
    const scrollbar_id = '#' + $('product-details-customize').find('.swiper-scrollbar').attr('id');
    new Swiper(swiper_id, {
      slidesPerView: 1.2,
      spaceBetween: 10,
      centeredSlides: true,
      grid: {
        fill: 'row',
        rows: 1,
      },
      watchOverflow: true,
      autoplay: {
        delay: 3000
      },
      breakpoints: {
        768: {
          slidesPerView: 1.6,
          grid: {
            fill: 'row',
            rows: 1,
          },
        },
        1024: {
          slidesPerView: 2,
          grid: {
            fill: 'row',
            rows: 2,
          }
        }
      },
      scrollbar: {
        el: scrollbar_id
      }
    });
  } else {
    new Swiper(swiper_id, {
      autoplay: {
        delay: 3000
      },
      navigation: {
        nextEl: button_next_id,
        prevEl: button_prev_id
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-design"]) return;
  try {
    
  var swiper_design = new Swiper('#swiper_design', {
    rewind: true,
    autoplay: true,
    observer: true,
    spaceBetween: 8,
    watchOverflow: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-story"]) return;
  try {
    
  $(document).ready(function () {
    $('.weaving_open').click(function () {
      $(this).closest('.weaving-content').toggleClass('active');
      $(this).closest('.weaving-content').find('.weaving_box').slideToggle('slow');
    });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-stylematch"]) return;
  try {
    
  var swiper_stylematch = new Swiper('#swiper_stylematch', {
    effect: 'fade',
    autoplay: true,
    pagination:{
      el: '.swiper-pagination'
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  var swiper_paired = new Swiper('#swiper_paired', {
    slidesPerView: 2,
    spaceBetween: 6,
    watchOverflow: true,
    observer:true,
    grid: {
      fill: 'row',
      rows: 1
    },
    breakpoints: {
      768: {
        slidesPerView: 3.2,
        spaceBetween: 10,
        grid: {
          fill: 'row',
          rows: 1
        }
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 12,
        grid: {
          fill: 'row',
          rows: 1
        }
      }
    },
    navigation: {
      nextEl: '#swiper_next_paired',
      prevEl: '#swiper_prev_paired'
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-new"] && !Shopify.designMode) return;
  try {
    
  class Countdown {
    constructor(el) {
      this.el = el;
      this.targetDate = new Date(el.getAttribute("date-time"));
      this.createCountDownParts()
      this.countdownFunction();
      this.countdownLoopId = setInterval(this.countdownFunction.bind(this), 1000)
    }
    createCountDownParts() {
      ["days", "hours", "minutes", "seconds"].forEach(part => {
        const wrapperEl = document.createElement("div");
        wrapperEl.classList.add("w-full", "aspect-w-4", 'aspect-h-3', "md:aspect-w-1", 'md:aspect-h-1');

        const partEl = document.createElement("div");
        partEl.classList.add("part", "w-full", "h-full", part);

        const textEl = document.createElement("div");
        textEl.classList.add("text");
        textEl.innerText = part;

        const numberEl = document.createElement("div");
        numberEl.classList.add("number");
        numberEl.innerText = 0;

        partEl.append(numberEl, textEl);
        wrapperEl.append(partEl);
        this.el.append(wrapperEl);

        this[part] = numberEl;
      })
    }

    countdownFunction() {
      const remaining = this.getTimes(this.targetDate);
      Object.entries(remaining).forEach(([part, value]) => {
        this[part].style.setProperty("--value", value)
        this[part].innerText = value
      })
    }

    getTimes = (time) => {
      const t = new Date(time).getTime();
      const offset = new Date().getTimezoneOffset() * 60 * 1000;
      const offsetTime = t - offset;
      return this.getPart(offsetTime);
    }

    getPart(endTime) {
      const current = Math.floor(Date.now() / 1000);
      let diff = Math.floor(endTime / 1000) - current;
      if (diff > 0) {
        let days = Math.floor(diff / (3600 * 24));
        let h = Math.floor((diff % (3600 * 24)) / (60 * 60));
        let m = Math.floor(((diff % (3600 * 24)) % (60 * 60)) / 60);
        let s = Math.floor(diff % 60);
        let hours = h < 10 ? "0" + h : h;
        let minutes = m < 10 ? "0" + m : m;
        let seconds = s < 10 ? "0" + s : s;
        return { days, hours, minutes, seconds }
      }
    }
  }
  const countdownEls = document.querySelectorAll(".countdown") || [];
  if (countdownEls.length > 0) {
    countdownEls.forEach(countdownEl => new Countdown(countdownEl));
  }

  let pixelGame_video_loaded = false;
  let pixelGame_video = document.getElementById('pixelGame_video');

  let slider2_video_loaded = false;
  let slider2_video = document.getElementById('slider2_video');

  let sm_video_loaded = false;
  let sm_video = document.getElementById('sm_video');
  var autoplay_options = {
    delay: 6000,
    stopOnLastSlide: false,
    pauseOnMouseEnter: true,
    disableOnInteraction: true
  }
  var autoplay = window.innerWidth > 1024 ? autoplay_options : true;
  var swiper_main = new Swiper('.hero-slider', {
    loop: true,
    //loopAdditionalSlides: 0,
    // rewind: true,
    autoplay: autoplay,
    observer: true,
    slidePerView: 1,
    spaceBetween : 8,
    touchRatio: 0.6,
    watchOverflow: true,
    observeParents: true,
    noSwiping: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination:{
      el: '.swiper-pagination',
      clickable: true
    },
    on: {
      init: function (swiper) {
        // if($('.hero-slider').find('.swiper-slide.hidden').length > 0){
        //   $('.hero-slider').find('.swiper-slide.hidden').remove();
        //   this.updateSlides();
        // }
        const activeIndex = this.activeIndex;
        if (pixelGame_video) {
          //$('#pixelGame_video').prev('.pixelGame-content').removeClass('active');
          pixelGame_video.addEventListener('loadedmetadata', function () {
            pixelGame_video_loaded = true;
            if (activeIndex == 0) {
              pixelGame_video.play();
            }
          });
        }
        if (slider2_video) {
          $('#slider2_video').prev('.slider2-content').removeClass('active');
          slider2_video.addEventListener('loadedmetadata', function () {
            slider2_video_loaded = true;
          });
        }
        if (sm_video) {
          sm_video.addEventListener('loadedmetadata', function () {
            sm_video_loaded = true;
          });
        }
      },
      slideChangeTransitionEnd: function () {
        const activeIndex = this.activeIndex;
        const realIndex = this.realIndex;
        //console.log(this.slides.length);
        // if (realIndex == 1) {
        //   $(".hero-slider>div[role='button']").find('path').css('fill', '#ffffff');
        // }else {
        //   $(".hero-slider>div[role='button']").find('path').css('fill', '#000000');
        // }

        if (pixelGame_video) {
          const pixelGame_index = $('#pixelGame_video').closest('.swiper-slide').index();
          if (activeIndex == pixelGame_index) {
            if (pixelGame_video_loaded) {
              pixelGame_video.play();
            }
          } else {
            pixelGame_video.pause();
            pixelGame_video.currentTime = 0;
            //$('#pixelGame_video').prev('.pixelGame-content').removeClass('active');
          }
        }
        if (slider2_video) {
          const slider2_index = $('#slider2_video').closest('.swiper-slide').index();
          //console.log(activeIndex,slider2_index);
          if (activeIndex == slider2_index) {
            if (slider2_video_loaded) {
              slider2_video.play();
            }
          } else {
            slider2_video.pause();
            slider2_video.currentTime = 0;
            $('#slider2_video').prev('.slider2-content').removeClass('active');
          }
        }
        if (sm_video) {
          const sm_index = $('#sm_video').closest('.swiper-slide').index();
          if (activeIndex == sm_index) {
            if (sm_video_loaded) {
              sm_video.play();
            }
          } else {
            sm_video.pause();
            sm_video.currentTime = 0;
          }
        }
      }
    }
  });
  if (sm_video) {
    sm_video.addEventListener('playing', function () {
      swiper_main.autoplay.stop();
    }, false);
    sm_video.addEventListener('ended', function () {
      swiper_main.autoplay.start();
    }, false);
  }

  if (slider2_video) {
    slider2_video.addEventListener('play', function () {
      setTimeout(function () {
        $('#slider2_video').prev('.slider2-content').addClass('active');
      }, 4500)
    }, false);

    slider2_video.addEventListener('playing', function () {
      swiper_main.autoplay.stop();
    }, false);

    slider2_video.addEventListener('ended', function () {
      swiper_main.autoplay.start();
    }, false);
  }

  if (pixelGame_video) {
    pixelGame_video.addEventListener('playing', function () {
      swiper_main.autoplay.stop();
    }, false);
    pixelGame_video.addEventListener('ended', function () {
      swiper_main.autoplay.start();
    }, false);
  }

  $(".hero-slider").hover(
    function () { swiper_main.autoplay.stop(); },
    function () { swiper_main.autoplay.start(); }
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  const countdownEls = document.querySelectorAll(".countdown") || [];
  if (countdownEls.length > 0) {
    class Countdown {
      constructor(el) {
        this.el = el;
        this.targetDate = new Date(el.getAttribute("date-time"));
        this.createCountDownParts()
        this.countdownFunction();
        this.countdownLoopId = setInterval(this.countdownFunction.bind(this), 1000)
      }
      createCountDownParts() {
        ["hours", "minutes", "seconds"].forEach(part => {
          const wrapperEl = document.createElement("div");
          wrapperEl.classList.add("w-full", "aspect-w-4", 'aspect-h-3');
          const partEl = document.createElement("div");
          partEl.classList.add("part", "w-full", "h-full", part);
          const textEl = document.createElement("div");
          textEl.classList.add("text");
          textEl.innerText = part;
          const numberEl = document.createElement("div");
          numberEl.classList.add("number");
          numberEl.innerText = 0;
          partEl.append(numberEl, textEl);
          wrapperEl.append(partEl);
          this.el.append(wrapperEl);
          this[part] = numberEl;
        })
      }
      countdownFunction() {
        const remaining = this.getTimes(this.targetDate);
        Object.entries(remaining).forEach(([part, value]) => {
          this[part].style.setProperty("--value", value)
          this[part].innerText = value
        })
      }
      getTimes = (time) => {
        const t = new Date(time).getTime();
        const offset = new Date().getTimezoneOffset() * 60 * 1000;
        const offsetTime = t - offset;
        return this.getPart(offsetTime);
      }
      getPart(endTime) {
        const current = Math.floor(Date.now() / 1000);
        let diff = Math.floor(endTime / 1000) - current;
        if (diff > 0) {
          let h = Math.floor((diff % (3600 * 24)) / (60 * 60));
          let m = Math.floor(((diff % (3600 * 24)) % (60 * 60)) / 60);
          let s = Math.floor(diff % 60);
          let hours = h < 10 ? "0" + h : h;
          let minutes = m < 10 ? "0" + m : m;
          let seconds = s < 10 ? "0" + s : s;
          return { hours, minutes, seconds }
        }
      }
    }
    countdownEls.forEach(countdownEl => new Countdown(countdownEl));
  }
  let banner_video = document.getElementById('banner_video');
  var autoplay = window.innerWidth > 1024 ? { delay: 6000 } : { delay: 3000 };
  var swiper_index_hero = new Swiper('#swiper_index_hero', {
    loop: true,
    autoplay: autoplay,
    slidesPerView: 1,
    spaceBetween: 12,
    observer: true,
    observeParents: true,
    noSwiping: true,
    pagination:{
      el: '#pagination_index_hero',
      clickable: true
    },
    on: {
      slideChangeTransitionEnd: function () {
        const activeIndex = this.activeIndex;
        if (banner_video) {
          const video_index = $('#banner_video').closest('.swiper-slide').index();
          if (activeIndex == video_index) {
            banner_video.play();
          } else {
            banner_video.pause();
            banner_video.currentTime = 0;
          }
        }
      },
      observerUpdate: function(){
        this.update();
      }
    }
  });

  if (banner_video) {
    banner_video.addEventListener('playing', function () {
      swiper_index_hero.autoplay.stop();
    }, false);
    banner_video.addEventListener('ended', function () {
      swiper_index_hero.slideNext(1000);
      swiper_index_hero.autoplay.start();
    }, false);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trade-in-2025"]) return;
  try {
    
  let scrollX,scrollY,scrollDirection;
  function getScrollAction() {
    if (typeof scrollX == 'undefined') {
      scrollX = window.pageXOffset;
      scrollY = window.pageYOffset;
      scrollDirection = 'down';
    }
    var diffX = scrollX - window.pageXOffset;
    var diffY = scrollY - window.pageYOffset;

    if (diffX < 0) {
      // Scroll right
      scrollDirection = 'right';
    } else if (diffX > 0) {
      // Scroll left
      scrollDirection = 'left';
    } else if (diffY < 0) {
      // Scroll down
      scrollDirection = 'down';
    } else if (diffY > 0) {
      // Scroll up
      scrollDirection = 'up';
    }
    scrollX = window.pageXOffset;
    scrollY = window.pageYOffset;
  }
  var Sticky_Anchor = new hcSticky('.anchor-points', {
    stickTo: '#sticky_container',
    bottomEnd: 112,
    onStart: function(){
      const h_header = $('.header-wrapper').height();
      const h_shop = $('#sticky_container').offset().top;
      window.onscroll = function (e) {
        getScrollAction();
        if (scrollY > h_shop) {
          $('#sticky_container>.anchor-points').css('position', 'fixed');
          if (scrollDirection  == 'up') {
            $('#sticky_container>.anchor-points').css('top', h_header);
          }else{
            $('#sticky_container>.anchor-points').css('top', 0);
          }
        }else{
          $('#sticky_container>.anchor-points').css('position', 'static');
        }
      }
    }
  });
  setTimeout(function(){
    Sticky_Anchor.refresh();
  },3000);

  $(function(){
    $('.accordion').accordion();
    $(".icon-copy").click(function (e) {
      e.stopPropagation();
      const $this = $(this);
      var con = $this.parent().next('.content').text();
      var text = con;
      var input = document.createElement("input");
      input.setAttribute("id", "copyInput");
      input.setAttribute("value", text);
      document.getElementsByTagName("body")[0].appendChild(input);
      document.getElementById("copyInput").select();
      document.execCommand("copy");
      document.getElementById("copyInput").remove();

      $this.next(".copy-mark").animate({
        opacity: 0.6
      }, 500, function () { });
      setTimeout(() => {
        $this.next(".copy-mark").animate({
          opacity: 0
        }, 500, function () { });
      }, 2000);
    });

    const anchorPointsH = $('#sticky_container>.anchor-points').height();
    $('#sticky_container>.anchor-points').on('click', 'a', function (e) {
      e.preventDefault();
      $(this).addClass('active').siblings().removeClass('active');
      let _anchorPoints = Array.from(document.querySelector("#sticky_container>.anchor-points").querySelectorAll("a[data-target^='#']"));

      const targetId = $(this).data('target');
      window.scrollTo({
        top: $(targetId).offset().top - 96,
        behavior: "smooth"
      });
    });

    $('.shopBtn').click(function(){
      $(this).closest('.grid-container').find('.grid-product-item').find('.form_btn-open').click();
    })
  })

  var swiper_s5 = new Swiper('#swiper_s5',{
    watchOverflow: true,
    autoplay: true,
    slidesPerView: 4,
    spaceBetween: 4,
    grid: {
      fill: 'row',
      rows: 2,
    },
    breakpoints:{
      768:{
        slidesPerView: 5,
        grid: {
          fill: 'row',
          rows: 2,
        },
      },
      1024:{
        slidesPerView: 6.8,
        grid: {
          fill: 'row',
          rows: 1,
        },
      },
      1280:{
        slidesPerView: 7.8,
        grid: {
          fill: 'row',
          rows: 1,
        },
      },
      1760:{
        slidesPerView: 8.2,
        grid: {
          fill: 'row',
          rows: 1,
        },
      },
      1920:{
        slidesPerView: 9,
        grid: {
          fill: 'row',
          rows: 1,
        },
      }
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-template"]) return;
  try {
    
  
  let Sticky_s3 = new hcSticky('#pagination_s2', {
    stickTo: '#ugc_content',
    onStart: function(){
      $('#pagination_s2').css({
        left: '50%',
        transform: 'translateX(-50%)'
      })
    },
    onStop: function(){
      $('#pagination_s2').css({
        left: 'unset',
        transform: 'none'
      })
    },
  });

  var swiper_s1 = new Swiper('#swiper_s1', {
    allowTouchMove: false,
    simulateTouch: false,
    speed: 1000
  })

  const slide_tag = location.hash;
  let initial_index = 0;
  if(slide_tag == '#aries'){
    initial_index = 1;
  }


  var swiper_s2 = new Swiper('#swiper_s2', {
    rewind: true,
    allowTouchMove: false,
    spaceBetween: 20,
    autoHeight: true,
    initialSlide: initial_index,
    preloadImages: true,
    updateOnImagesReady: true,
    pagination: {
      el: '#pagination_s2',
      clickable: true,
      renderBullet: function (index, className) {
        switch(index){
          case 0: text = 'This is my PITAKA'; break;
          case 1: text = 'My Glowing Time'; break;
        }
        return '<div class="' + className + '"><span class="text-size-14 xs:text-size-16 sm:text-size-18 lg:text-size-20 xl:text-size-24">' + text + '</span></div>';
      }
    },
    on:{
      init:function(){
        this.emit('slideChange');
      },
      slideChange: function(){
        const index = this.realIndex;
        swiper_s1.slideTo(index, 1000, false);
      }
    }
  });

  // console.log($('#pagination_s2').length)
  if ($('#pagination_s2').length == 0) {
    swiper_s1.disable();
    swiper_s2.disable();
  }

  document.querySelectorAll('.swiper_prizes').forEach(swiper_item => {
    const swiper_id = '#' + swiper_item.id;
    new Swiper(swiper_id, {
      slidesPerView: 1,
      spaceBetween: 10,
      grid: {
        fill: 'row',
        rows: 4
      },
      watchOverflow: true,
      breakpoints: {
        768: {
          slidesPerView: 1.4,
          grid: {
            fill: 'row',
            rows: 1
          }
        },
        1024: {
          slidesPerView: 3.2,
          grid: {
            fill: 'row',
            rows: 1
          }
        },
        1280: {
          slidesPerView: 4,
          grid: {
            fill: 'row',
            rows: 1
          }
        }
      }
    })
  });

  document.querySelectorAll('.swiper_products').forEach(swiper_item => {
    const swiper_id = '#' + swiper_item.id;
    const button_prev_id = '#button_prev_' + swiper_item.id.split('_')[1];
    const button_next_id = '#button_next_' + swiper_item.id.split('_')[1];
    new Swiper(swiper_id, {
      slidesPerView: 2.2,
      spaceBetween: 6,
      watchOverflow: true,
      breakpoints: {
        768: {
          slidesPerView: 3.2,
          spaceBetween: 10
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 12
        }
      },
      navigation: {
        nextEl: button_next_id,
        prevEl: button_prev_id,
      }
    });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watch-bands-clearance-template"]) return;
  try {
    

var swiper_s3 = new Swiper('#swiper_s3',{
  watchOverflow: true,
  autoplay: {
    delay: 3000,
    stopOnLastSlide: false,
    disableOnInteraction: true,
  },
  speed: 1000,
  slidesPerView: 1,
  spaceBetween: 8,
  breakpoints: {
    768: {
      slidesPerView: 1.6,
      spaceBetween: 12
    },
    1024: {
      slidesPerView: 2.2,
      spaceBetween: 12
    },
    1280: {
      slidesPerView: 3,
      spaceBetween: 12
    },
    1760: {
      slidesPerView: 3,
      spaceBetween: 16
    }
  }
})

  } catch(e) { console.error(e); }
})();
})();
